import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import ShoppingCartContent from '@Components/Results/structure/availability/ShoppingCartContent';
import { shoppingCartStatusCheck } from '@Components/Results/structure/availability/ShoppingCartHelper';

function ShoppingCart(props) {
  const [status, setStatus] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const { availability, structure, allowCommercialDBOnly } = props;

    shoppingCartStatusCheck({ availability, structure, allowCommercialDBOnly })
      .then((result) => {
        if (isMounted) setStatus(result);
      })
      .catch(Logger.error);

    return () => {
      isMounted = false;
    };
  }, [props.availability, props.structure, props.allowCommercialDBOnly]);

  if (!status) {
    return null;
  }
  return <ShoppingCartContent {...props} />;
}

ShoppingCart.propTypes = {
  availability: PropTypes.object.isRequired,
  structure: PropTypes.object.isRequired,
  trackingContext: PropTypes.string,
  onOpen: PropTypes.func,
  onOptionClick: PropTypes.func,
  tooltipId: PropTypes.string,
  allowCommercialDBOnly: PropTypes.bool,
  trackingContent: PropTypes.array,
};

export default ShoppingCart;
